<template>
<div>
    <transition name="slide-fade">
        <div class="pdpa-modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-head-coin"></div>
                <div class="relative mobile-top pb-4 pt-4">
                    <div class="flex justify-center">
                        <img class="logo-size" src="@/assets/logo/tipcoin-logo-top.png">
                    </div>
                </div>
                <div class="mt-10 sm:mx-8 sm:mt-16 sm:pb-60">
                    <div class="page-content bg-white sm:px-8 mb-2 pb-4 px-5 py-6 mt-10 mx-2 rounded-25">
                        <div class="text-24 text-tc-blue-2 text-center">
                            {{lbl.register.title_terms}}
                        </div>
                        <div class="pt-3 pb-5 content text-20 text-tc-gray-3" v-html="content1"></div>
                        <div class="text-24 text-tc-blue-2 text-center">
                            {{lbl.register.title_terms2}}
                        </div>
                        <div class="pt-3 pb-24 content text-20 text-tc-gray-3" v-html="content2"></div>
                        <div class="w-full sm:w-309px mx-auto mt-4 sm:mt-14">
                            <BlueBtn @onClick="onOk()">{{ btnOk }}</BlueBtn>
                        </div>
                </div>
            </div>
        </div>
            <BottomBar></BottomBar>
        </div>
    </transition>
</div>
</template>

<script>
import BlueBtn from "@/components/Button/BlueBtn.vue";
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'Pdparegistermodal',
    mixins: [LocaleMixin],
    components:{
        BlueBtn,
        BottomBar,
    },
    props: {
        controller: { type: Object }
    },
    data: function() {
        return {
            open: false,
            title: '',
            content: '',
            btnOk: '',
            content1: '',
            content2: ''
        };
    },

    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods:{
        onOk: function () {
            this.hide();
            this.controller.sendCallbackOk(this.version);
        },
        onCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        show: function (config) {
            this.title = config.title;
            this.content1 = config.msg1;
            this.content2 = config.msg2;
            this.btnOk = config.btnOk;
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        }
    }
};
</script>

<style lang="scss" scoped>
 @import "@/style/base/base.scss";
    .content{
        text-indent: 2em;
    }
    .logo-size {
        width: 100px;
        height: 90px;
        @include mobile {
            width: 65px; //53px
            height: 58px;
        }
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
    @include mobile {
        .height-contents {
            min-height: 65vh
        }
    }
</style>
